import { FC, TextareaHTMLAttributes } from 'react';
import { cn } from '../../../utils/helpers';

interface Props extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  className?: string;
}

const Textarea: FC<Props> = ({ name, label, value, className, ...rest }) => {
  return (
    <div className={cn('relative', className)}>
      <label
        htmlFor={name}
        className={cn(
          'absolute',
          'transition-all duration-100',
          !value ? 'top-4 text-sm left-4 text-content' : 'top-[-7px] bg-white text-xs px-1 left-3 text-raisin-black',
        )}
      >
        {label}
      </label>
      <textarea
        id={name}
        className={cn('w-full', 'outline-none border border-[#DADADA]', 'disabled:bg-white', 'rounded p-4 text-sm')}
        name={name}
        defaultValue={value}
        {...rest}
      />
    </div>
  );
};

export default Textarea;
